/* Model */
class TaskResolutionModel extends App.Models.BaseModel {
    modelUrl = 'TaskResolution';
  }
  
  App.Models.TaskResolution = TaskResolutionModel;
  
  /* Collection */
  class TaskResolutionCollection extends App.Collections.BaseCollection {
    url = 'TaskResolution';
    model = App.Models.TaskResolution;
  }
  
  App.Collections.TaskResolutions = TaskResolutionCollection;
  
  /* Router */
  class TaskResolutionRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'TaskResolution';
        const model = App.Models.TaskResolution;
        const collectionClass = App.Collections.TaskResolutions;
  
        super(entityName, model, collectionClass);
    }
  }
  
  App.Routers.TaskResolution = TaskResolutionRouter;